import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { flexKeys, flexMixin } from '../mixins/flex';
import { boxSizingKeys, boxSizingMixin, fullHeightKeys, fullHeightMixin, fullWidthKeys, fullWidthMixin, marginKeys, marginMixin, paddingKeys, paddingMixin } from '../mixins/layout';
import { withOmitProps, byMedia, getPx } from '../helpers';

/**
 * more about it https://alistapart.com/article/axiomatic-css-and-lobotomized-owls/
 */
var createGap = function createGap(direction, value) {
  var _;

  return {
    '& > * + *': (_ = {}, _['margin-' + direction] = getPx(value), _)
  };
};

var mediaGap = byMedia(function (v) {
  return "gap: " + getPx(v) + ";";
});

var rowGapMixin = function rowGapMixin(_ref) {
  var rowGap = _ref.rowGap;
  return rowGap && createGap('left', rowGap);
};

var columnGapMixin = function columnGapMixin(_ref2) {
  var columnGap = _ref2.columnGap;
  return columnGap && createGap('top', columnGap);
};

var gapMixin = function gapMixin(_ref3) {
  var gap = _ref3.gap;
  return gap && mediaGap(gap);
};

var Flex = styled.div.withConfig(withOmitProps([].concat(boxSizingKeys, fullWidthKeys, fullHeightKeys, flexKeys, marginKeys, paddingKeys, ['rowGap', 'columnGap', 'gap'])))(_templateObject(), boxSizingMixin, fullWidthMixin, fullHeightMixin, flexMixin, marginMixin, paddingMixin, rowGapMixin, columnGapMixin, gapMixin);
export default Flex;